<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Lincoln County</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head2" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">Each day, a little bit of history is lost or disappears. We hope that, through our endeavors, a few photographs and memories of Lincoln County, Mississippi, have been preserved for you to enjoy.</p>
<p class="para">Our sincere gratitude is expressed to the following individuals, without whose assistance this book would not have been created: Lincoln-Lawrence-Franklin Regional Library director Henry Ledet, board, and staff for the use of its vast collection of photographs and resources; all the individuals who participated in our scanning days by bringing photographs and information; Lincoln County Historical and Genealogical Society president Carroll Montgomery; Terry Pappas; Maxine Allen; Lincoln County Baptist Association and secretary Lisa Burt; countless individuals we called and visited who provided information; our title manager, Liz Gurley, and the staff at Arcadia Publishing; and, most importantly, our families, who love us and tolerate our endless pursuits of history.</p>
<p class="para">Finally, to the historians and genealogists no longer with us who recorded times gone by and told their stories for future generations, we say “thank you.”</p>
<p class="para">Images from the following sources are credited with abbreviated forms: the Lincoln-Lawrence-Franklin Regional Library (LLF), the Lincoln County Historical and Genealogical Society Museum (LCHGS), and the Mississippi Department of Archives and History (MDAH).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?1fcd09f0